<template>
    <div id="app">
        <router-view :key="$route.fullPath"></router-view>
    </div>
</template>

<script>
    export default {
        name: 'app'
    };
</script>

<style src="./assets/styles/app.less" lang="less"></style>



// WEBPACK FOOTER //
// App.vue?db4c7c7e